import Icon from '@mui/material/Icon';
import IconButton from '@mui/material/IconButton';
import * as Actions from 'app/store/actions';
import React from 'react';
import { useDispatch } from 'app/modules/react-redux';

const NavbarMobileToggleButton = ({ className = '', children = <Icon>menu</Icon> }) => {
	const dispatch = useDispatch();

	return (
		<IconButton
			className={`${className} starter:text-white landing-toolbar-text-white`}
			onClick={(_ev) => dispatch(Actions.navbarToggleMobile())}
			// disableRipple
			style={{ height: 32, width: 32, margin: 4 }}
			size="large"
		>
			{children}
		</IconButton>
	);
};

export default NavbarMobileToggleButton;
